import {BaseHandler} from "./BaseHandler";
import tinymce, {Editor} from 'tinymce';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/icons/default';
import 'tinymce/';
import {Popup} from "../Popups/Popup";
import $ from "jquery";
import {GetModels, PrintModelEntry, Var} from "../Api/Types";

const htmlStart = `<!doctype html>
<html lang="{lingua}">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Smartprise</title>

    <style>
        body {
            margin: 0
        }

        #logo-container {
            width: 12.5cm;
            height: 5.3cm;
            vertical-align: top;
        }

        #logo-container > img:first-child {
            margin-top: 0.7cm
        }

        #letter-body {
            margin-top: 1.5cm;
        }

        #letter-body > h4 {
            color: red;
            text-align: center
        }

        #verbals-container tr:not(#verbals-final-row) > th,
        #verbals-container tr:not(#verbals-final-row) > td {
            border: solid cyan 1px;
            font-size: 13px
        }

        #verbals-final-row > td {
            border: solid cyan 1px
        }

        #verbals-final-row > td:last-child {
            text-align: right
        }

        #payments-info {
            border: solid cyan 1px;
            text-align: center;
            padding-top: 8px;
            padding-bottom: 8px
        }

        #payments-info > b {
            display: block;
        }

        #barcode-wrapper {
            width: 8.7cm;
            height: 2cm;
            text-align: center;
        }

        #header-info p {
            margin: 0
        }
    </style>
</head>
<body style="margin: 0">`;
const htmlEnd = `</body>
</html>`;

const x = window.location.pathname.split("/");
x.pop();
(tinymce as any).baseURL = x.join("/") + "/ui/resources/js//tinymce";

export class TemplateHandler extends BaseHandler {
    private print_model_entry: PrintModelEntry;
    private getModels: GetModels;
    private modelTitleToId: Map<string, number> = new Map();
    private current_entry: PrintModelEntry;

    private availableVars: Var[] = [];
    private currentEntries: PrintModelEntry[] = [];

    public override handle(): void {
        super.handle();

        this.hideTranslationStats();

        this.client.get_print_models().ew_done((response) => {
            this.availableVars = response.vars
            this.getModels = response;
            this.loadPrintModels(response);
            this.setupLanguageInputTrigger();
            this.setupTriggers();
            this.initTinyMCE();
        });
    }

    private setupTriggers() {
        this.setUpShowMissingLangs();
        this.setUpLoad();
        this.setUpCancelSaveModelBtn();
    }

    private clearEditorHistory(editor:Editor) {
        editor.undoManager.clear();
    }

    private getValidationData() {
        const $languageInput = $('#language-input');
        const $modelInput = $('#model-input');
        const langVal = $languageInput.val() as string;
        const modelVal = $modelInput.val() as string;

        const $languageOptions = $('#language-selector option');
        const $modelOptions = $('#model-selector option');

        const validLangCodes = new Set<string>();
        const labelToLangCode = new Map<string, string>();
        $languageOptions.each(function () {
            const val = $(this).val() as string;
            const label = $(this).attr('label');
            if (val) validLangCodes.add(val);
            if (label) labelToLangCode.set(label.toLowerCase(), val);
        });

        const validModelTitles = new Set<string>();
        $modelOptions.each(function () {
            const val = $(this).val() as string;
            if (val) validModelTitles.add(val);
        });

        let finalLangCode: string | undefined;
        if (validLangCodes.has(langVal)) {
            finalLangCode = langVal;
        } else {
            finalLangCode = labelToLangCode.get(langVal.toLowerCase());
        }

        const modelId = this.modelTitleToId.get(modelVal.toLowerCase());

        return { langVal, modelVal, finalLangCode, modelId, validLangCodes, labelToLangCode, validModelTitles };
    }

    private validateModelAndLang(
        langVal: string,
        modelVal: string,
        validLangCodes: Set<string>,
        validModelTitles: Set<string>,
        finalLangCode: string | undefined,
        modelId: number | undefined
    ) {
        if (!finalLangCode) {
            this.showErrorPopup("Lingua non valida. Per favore sceglierla dalla lista.");
            return false;
        }

        if (!validModelTitles.has(modelVal)) {
            this.showErrorPopup("Modello non valido. Per favore sceglierlo dalla lista.");
            return false;
        }

        if (!modelId) {
            this.showErrorPopup("Modello non valido. Per favore sceglierlo dalla lista.");
            return false;
        }

        return true;
    }

    private showErrorPopup(message: string) {
        const t = Popup.DefaultErrorInject(message, "Error", false);
        const set_animation = (d: JQuery.Deferred<any>) => {
            d.done(() => {
                alert();
                t.popup.Remove();
            });

            d.always((x: JQuery.Deferred<any>) => set_animation(x));
        };

        set_animation(t.deferred);
    }

    private loadModelContent(editor: Editor, entries: PrintModelEntry[], finalLangCode: string) {
        const entry = entries.find(e => e.lang_code.toLowerCase() === finalLangCode.toLowerCase());

        this.print_model_entry = entry

        if (entry) {
            editor.setContent(entry.content);
        } else {
            editor.setContent(`<p>Nessun template disponibile per la lingua: ${finalLangCode}</p>`);
        }
    }

    private setupSaveModelButton(entries: PrintModelEntry[]) {
        const $saveModelButton = $('#save-model-btn');

        $saveModelButton.off('click').on('click', () => {
            const editor = tinymce.get('editor');
            if (!editor) return;

            const content = editor.getContent();

            const entry = entries.find(e => e.lang_code.toLowerCase() === $('#language-input').val()?.toString().toLowerCase());
            if (!entry) {
                this.showErrorPopup("Nessun modello trovato per la lingua selezionata.");
                return;
            }
            let start = htmlStart.replace('{lingua}', entry.lang_code);

            this.client.update_print_model_content(entry.print_model_entry_id, start + content + htmlEnd).ew_done(() => {
                this.success_popup("Modello aggiornato con successo");
                this.client.get_print_model_entries(entry.ref_print_model_id).ew_done((e) => {
                    this.print_model_entry = entries.find(e => e.lang_code.toLowerCase() === $('#language-input').val()?.toString().toLowerCase());
                    this.current_entry = entries.find(e => e.lang_code.toLowerCase() === $('#language-input').val()?.toString().toLowerCase());
                    this.updateShowedNumbers(e);
                })
            });
        });
    }


    private loadPrintModels(response: GetModels): void {
        this.modelTitleToId.clear(); // ✅ important

        const $languageDatalist = $('#language-selector');
        const $modelDatalist = $('#model-selector');
        const $languageInput = $('#language-input');
        const $modelInput = $('#model-input');

        if ($languageDatalist.length === 0 || $languageInput.length === 0) {
            console.error('Language datalist or input not found');
            return;
        }

        if ($modelDatalist.length === 0 || $modelInput.length === 0) {
            console.error('Model datalist or input not found');
            return;
        }

        $languageDatalist.html('');
        $modelDatalist.html('');

        const languageNames = new Intl.DisplayNames(['it'], {type: 'language'});

        response.languages
            .sort((a, b) => (languageNames.of(a) || a).localeCompare(languageNames.of(b) || b))
            .forEach(langCode => {
                const $option = $('<option>')
                    .val(langCode)
                    .attr('label', languageNames.of(langCode) || langCode);
                $languageDatalist.append($option);
            });

        response.print_models
            .sort((a, b) => a.title.localeCompare(b.title))
            .forEach(printModel => {
                const title = printModel.title;
                const id = printModel.print_model_id;

                const $option = $('<option>')
                    .val(title)
                    .attr('label', title);
                $modelDatalist.append($option);

                this.modelTitleToId.set(title.toLowerCase(), id);
            });
    }

    private setupLanguageInputTrigger(): void {
        const $languageInput = $('#language-input');
        const $modelInput = $('#model-input');
        const $createNewModelBtn = $('#create-model-btn');

        $createNewModelBtn.on('click', () => {
            const $model_name = $('#new-model-name');
            let new_model_name = $model_name.val()?.toString() || '';
            new_model_name = new_model_name.trim().replace(/\s+/g, ' ');

            if (new_model_name !== '') {
                this.client.create_print_model(new_model_name).ew_done(() => {
                    this.success_popup("Nuovo modello creato");

                    this.client.get_print_models().ew_done((response) => {
                        this.getModels = response;
                        this.modelTitleToId.clear();
                        this.loadPrintModels(response);

                        setTimeout(() => {
                            $modelInput.val(new_model_name);
                            $('#load').trigger('click');
                        }, 50);
                    });
                });

                $model_name.val('');
            } else {
                this.showErrorPopup("Inserire un nome di modello non vuoto");
            }
        });

        this.toggleInputListOnFocus($languageInput, 'language-selector');
        // this.toggleInputListOnFocus($modelInput, 'model-selector');
    }

    private toggleInputListOnFocus(inputElement: JQuery, listId: string) {
        inputElement.removeAttr('list');
        inputElement.on('input focus', function () {
            const value = $(this).val() as string;
            if (value.length >= 1) {
                $(this).attr('list', listId);
            } else {
                $(this).removeAttr('list');
            }
        });
    }

    private initTinyMCE() {
        tinymce.init({
                license_key: 'gpl',
                selector: "#editor",
                height: 500,
                promotion: false,
                menubar: 'edit view insert format tools table help',
                plugins: 'lists link table code fullscreen',
                toolbar: 'varsButton iterazioniButton |undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | code fullscreen customPreview',
                table_toolbar: 'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                toolbar_mode: 'sliding',
                contextmenu: 'link image table',
                quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote',
                image_title: true,
                automatic_uploads: true,
                file_picker_types: 'image',
                paste_data_images: true,
                statusbar: true,

                setup: (editor: Editor) => {
                    editor.ui.registry.addMenuButton('varsButton', {
                        text: 'Vars',
                        fetch: (callback) => {
                            const items = this.availableVars
                                .filter(v => v.type === 'var')
                                .map(v => ({
                                    type: 'menuitem' as const,
                                    text: v.display_name,
                                    onAction: () => editor.insertContent(`{{${v.name}}} `)
                                }))
                                .sort((a, b) => a.text.localeCompare(b.text));
                            callback(items);
                        }
                    });

                    editor.ui.registry.addMenuButton('iterazioniButton', {
                        text: 'Iterazioni',
                        fetch: (callback) => {
                            const items = this.availableVars
                                .filter((v): v is Extract<Var, {
                                    type: 'macro'
                                }> => v.type === 'macro')
                                .map(v => ({
                                    type: 'menuitem' as const,
                                    text: v.display_name,
                                    onAction: () => editor.insertContent(`<br>${v.block_init}<br><br>${v.block_end}<br>`)
                                }))
                                .sort((a, b) => a.text.localeCompare(b.text));
                            callback(items);
                        }
                    });

                    editor.ui.registry.addButton('customPreview', {
                        icon: 'preview',
                        onAction: () => {
                            this.client.get_print_model_entry_preview(this.print_model_entry?.print_model_entry_id ?? 6).ew_done((Html) => {
                                const previewWindow = window.open('', 'PreviewWindow', 'width=900,height=600,resizable=yes,scrollbars=yes');
                                if (previewWindow) {
                                    previewWindow.document.open();
                                    const lang = this.print_model_entry?.lang_code ?? 'en';
                                    const fullHtml= Html.html;
                                    previewWindow.document.write(fullHtml);
                                    previewWindow.document.close();
                                } else {
                                    this.showErrorPopup("Errore durante la richiesta di preview");
                                }
                            });
                        }
                    });

                    editor.on('init', () => {
                        const branding = document.querySelector('.tox-statusbar__branding');
                        if (branding) branding.remove();
                    });
                },
            }
        );
    }

    private showMissingLangPopup(message: string) {
        const t = Popup.DefaultErrorInject(message, "Lingue mancanti", true);
        const set_animation = (d: JQuery.Deferred<any>) => {
            d.done(() => {
                t.popup.Remove();
            });

            d.always((x: JQuery.Deferred<any>) => set_animation(x));
        };

        set_animation(t.deferred);
    }

    private updateShowedNumbers(entries: PrintModelEntry[]) {
        const numberOfModels = entries.length;
        let todo = 0;
        let done = 0;

        const langsDone = new Set<string>();
        const langsMissing: string[] = [];

        entries.forEach((e) => {
            if (e.content.trim().length > 100) {
                done++;
                langsDone.add(e.lang_code.toLowerCase());
            }
        });

        this.getModels.languages.forEach(lang => {
            if (!langsDone.has(lang.toLowerCase())) {
                langsMissing.push(lang);
            }
        });

        $('#models-done').text(done.toString());
        $('#models-todo').text((numberOfModels - done).toString());

        if (langsMissing.length > 0) {
            const languageNames = new Intl.DisplayNames(['it'], {type: 'language'});
            const sortedList = langsMissing
                .sort((a, b) => (languageNames.of(a) || a).localeCompare(languageNames.of(b) || b))
                .map(code => `${languageNames.of(code) || code} (${code})`)
                .join('<br>');

            const message = `<strong>Lingue senza modello:</strong><br><br>${sortedList}`;
        } else {
            $('#language-missing-box').hide();
        }

        $('#editor-actions').before($('#language-missing-box'));
        this.showTranslationStats();
    }

    private hideTranslationStats() {
        $('#translation-stats').css('display', 'none');
    }

    private showTranslationStats() {
        $('#translation-stats').css('display', 'block');
    }

    private setUpShowMissingLangs() {
        $('#show-missing-langs').off('click').on('click', () => {
            const langsMissing: string[] = [];

            const langsDone = new Set<string>();
            const entries = this.currentEntries;

            entries.forEach((e) => {
                if (e.content.trim().length > 100) {
                    langsDone.add(e.lang_code.toLowerCase());
                }
            });

            this.getModels.languages.forEach(lang => {
                if (!langsDone.has(lang.toLowerCase())) {
                    langsMissing.push(lang);
                }
            });

            if (langsMissing.length > 0) {
                const languageNames = new Intl.DisplayNames(['it'], { type: 'language' });
                const sortedList = langsMissing
                    .sort((a, b) => (languageNames.of(a) || a).localeCompare(languageNames.of(b) || b))
                    .map(code => `${languageNames.of(code) || code} (${code})`)
                    .join('<br>');

                const message = `<strong>Lingue senza modello:</strong><br><br>${sortedList}`;
                this.showMissingLangPopup(message);
            } else {
                this.success_popup("Tutte le lingue sono coperte da almeno un modello.");
            }
        });
    }

    private setUpLoad() {
        $('#load').on('click', () => {
            const { langVal, modelVal, finalLangCode, modelId, validLangCodes, labelToLangCode, validModelTitles } = this.getValidationData();

            if (!this.validateModelAndLang(langVal, modelVal, validLangCodes, validModelTitles, finalLangCode, modelId)) {
                return;
            }

            this.hideTranslationStats()
            this.client.get_print_model_entries(modelId).ew_done((entries: PrintModelEntry[]) => {
                this.currentEntries = entries;
                const editor = tinymce.get('editor');
                if (!editor) {
                    console.error("TinyMCE editor is not initialized.");
                    return;
                }

                this.loadModelContent(editor, entries, finalLangCode);
                this.setupSaveModelButton(entries);
                this.updateShowedNumbers(entries);
            });
        });
    }

    private setUpCancelSaveModelBtn() {
        $('#cancel-save-model-btn').off('click').on('click', () => {
            const editor = tinymce.get('editor');
            editor.setContent(this.current_entry.content);
            this.clearEditorHistory(editor)
        })
    }
}
